/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Find_Replace_Prev_Result_Aria_LabelInputs */

const en_find_replace_prev_result_aria_label = /** @type {(inputs: Find_Replace_Prev_Result_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous result`)
};

const fr_find_replace_prev_result_aria_label = /** @type {(inputs: Find_Replace_Prev_Result_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultat precedent`)
};

const de_find_replace_prev_result_aria_label = /** @type {(inputs: Find_Replace_Prev_Result_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorheriges Ergebnis`)
};

const it_find_replace_prev_result_aria_label = /** @type {(inputs: Find_Replace_Prev_Result_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risultato precedente`)
};

const ru_find_replace_prev_result_aria_label = /** @type {(inputs: Find_Replace_Prev_Result_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предыдущий результат`)
};

const es_find_replace_prev_result_aria_label = /** @type {(inputs: Find_Replace_Prev_Result_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultado anterior`)
};

const zh_cn2_find_replace_prev_result_aria_label = /** @type {(inputs: Find_Replace_Prev_Result_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先前结果`)
};

const ja_find_replace_prev_result_aria_label = /** @type {(inputs: Find_Replace_Prev_Result_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前回の結果`)
};

const hi_find_replace_prev_result_aria_label = /** @type {(inputs: Find_Replace_Prev_Result_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछला परिणाम`)
};

const pt_pt2_find_replace_prev_result_aria_label = /** @type {(inputs: Find_Replace_Prev_Result_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resultado anterior`)
};

/**
* | output |
* | --- |
* | "Previous result" |
*
* @param {Find_Replace_Prev_Result_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const find_replace_prev_result_aria_label = /** @type {((inputs?: Find_Replace_Prev_Result_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Replace_Prev_Result_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_find_replace_prev_result_aria_label(inputs)
	if (locale === "de") return de_find_replace_prev_result_aria_label(inputs)
	if (locale === "it") return it_find_replace_prev_result_aria_label(inputs)
	if (locale === "ru") return ru_find_replace_prev_result_aria_label(inputs)
	if (locale === "es") return es_find_replace_prev_result_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_find_replace_prev_result_aria_label(inputs)
	if (locale === "ja") return ja_find_replace_prev_result_aria_label(inputs)
	if (locale === "hi") return hi_find_replace_prev_result_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_find_replace_prev_result_aria_label(inputs)
	return en_find_replace_prev_result_aria_label(inputs)
});